(function ($, Drupal, drupalSettings, once) {

  'use strict';

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Globally accessible API
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Promutuel.storeLocation = {
    populateCard: function (container, { overtitle, title, url, toll_free, phone, fax, email, hours, hours_comment, address }) {
      container.querySelector('[data-field=overtitle]').textContent = overtitle ?? '';
      container.querySelector('[data-field=title]').textContent = title ?? '';
      if (container.querySelector('[data-field=link]')) container.querySelector('[data-field=link]').href = url ?? '';
      if (container.querySelector('[data-field=toll_free]')) {
        container.querySelector('[data-field=toll_free]').textContent = toll_free ?? '';
        container.querySelector('[data-field=toll_free]').href = "tel:" + toll_free?.replaceAll(/[^0-9+]/gi, "");
      }
      container.querySelector('[data-field=phone]').textContent = phone ?? '';
      container.querySelector('[data-field=phone]').href = "tel:" + phone?.replaceAll(/[^0-9+]/gi, "");
      container.querySelector('[data-field=fax]').textContent = fax ?? '';
      if (container.querySelector('[data-field=email]')) {
        container.querySelector('[data-field=email]').textContent = email ?? '';
        container.querySelector('[data-field=email]').href = "mailto:" + encodeURIComponent(email ?? '');
      }

      const hoursPanel = container.querySelector('.js-stoloccard-hours');
      hoursPanel.querySelectorAll('[data-dow]').forEach(row => {
        const dow = parseInt(row.dataset.dow, 10);
        row.querySelector('[data-field=dow]').textContent = drupalSettings.weekdays[dow];
        row.querySelector('[data-field=hours]').textContent = formatHours(hours, dow);
      });
      hoursPanel.querySelector('[data-field=comment]').textContent = hours_comment ?? '';

      this.populateTodayHours(container);

      container.querySelector('[data-field=address]').textContent = "";
      address?.forEach(line => {
        container.querySelector('[data-field=address]').appendChild(createTextDiv(line))
      });
    },

    populateTodayHours: function (container) {
      const hoursPanel = container.querySelector('.js-stoloccard-hours');
      const today = (new Date()).getDay();
      const todayRow = hoursPanel.querySelector(`[data-dow='${today}']`);

      container.querySelector('[data-field=todayhours]').textContent =
        todayRow?.querySelector('[data-field=hours]').textContent;

      container.querySelector('[data-field=openinghours-comment]').textContent =
        hoursPanel.querySelector('[data-field=comment]').textContent || '\xa0'; //xa0 = non-breaking space
    }
}

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_storeLocationCard = {
    attach: function attach(context) {

      $(once('promutuelStoreLocationCard', '.js-stoloccard', context)).each(function (i, container) {
        const header = container.querySelector('.js-stoloccard-header');
        const hoursPanel = container.querySelector('.js-stoloccard-hours');
        const hoursAnchor = container.querySelector('.js-stoloccard-openinghours-toggle');

        if (hoursPanel && hoursAnchor) {
          Promutuel.storeLocation.populateTodayHours(container);
        }

        // "See all opening hours" link click handler
        container.querySelector('.js-stoloccard-openinghours-toggle')?.addEventListener('click', event => {
          event.preventDefault();

          hoursPanel.removeAttribute('hidden');

          // // Make the "All opening hours" panel fill the bottom space.
          // hoursPanel.style.height = `${container.offsetHeight - header.offsetHeight}px`;

          setTimeout(_ => {
            hoursPanel.classList.add('store-location-card__hoursoverlay--open');
            // Make the "All opening hours" panel fill the bottom space.
            hoursPanel.style.height = `${container.offsetHeight - header.offsetHeight}px`;
          }, 1); // Timeout to allow transition trigger.
        });

        // "All opening hours" panels's close button click handler
        container.querySelector('.js-stoloccard-close')?.addEventListener('click', event => {
          event.preventDefault();
          hoursPanel.style.height = '';
          hoursPanel.classList.remove('store-location-card__hoursoverlay--open');
          setTimeout(_ => {
            hoursPanel.hidden = true;
          }, 200); // Timeout to allow transition trigger.
        });
      });
    }
  };

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Utilities
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  /**
   * Utility DOM function
   */
  function createTextDiv(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div;
  }

  function formatTime(timeInMilitaryFormat) {
    timeInMilitaryFormat = timeInMilitaryFormat.toString();
    const language = document.documentElement.lang;

    if (
      language == "fr"
      && timeInMilitaryFormat.slice(-2) == 0
    ) return Drupal.t('@h:', {
      '@h': timeInMilitaryFormat.slice(0, -2)
    });
    else return Drupal.t('@h:@m', {
      '@h': timeInMilitaryFormat.slice(0, -2),
      '@m': timeInMilitaryFormat.slice(-2)
    });
  }

  function formatHours(hours, day) {
    if (!hours) return '';
    return hours.filter(item => item.day.toString() === day.toString())
      .map(item => {
        if (
          item.starthours
          && item.starthours !== "-1"
          && item.endhours && item.endhours !== "-1"
        ) return Drupal.t('@start to @end', {
          '@start': formatTime(item.starthours),
          '@end': formatTime(item.endhours)
        }) + (item.comment ? (' ' + item.comment) : '');
        else return item.comment;
      }).join(Drupal.t(' and ')) || Drupal.t('Closed');
  }

})(jQuery, Drupal, drupalSettings, once);
